import React from "react";
import { Image } from "antd";
import { useSearchParams } from "react-router-dom";
import { StyledErrorPage } from "../not-found/ErrorStyledComponent";
import { CustomTitle, FlexWrap } from "../StyledComponent";
import { registrationErrorCopy } from "./copy";

function Index() {
  const [searchParams] = useSearchParams();

  const error = searchParams.get("error") || "";
  const cloud = searchParams.get("cloud") || "";

  const { headline, nextStep } = registrationErrorCopy(error, cloud);

  return (
    <StyledErrorPage>
      <Image preview={false} src='/images/error-state.svg' />
      <FlexWrap flexDir='column'>
        <CustomTitle fontSize={18} lineheight={28} color='#0e121b'>
          {headline}
        </CustomTitle>
        <CustomTitle mt={8} fontSize={14} lineheight={22} color='#525866'>
          {nextStep}
        </CustomTitle>
      </FlexWrap>
    </StyledErrorPage>
  );
}

export default Index;
